exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nsection { font-family: 'Open Sans',sans-serif;\n}\n.u-section-Banner .u-sheet-1 {min-height: 451px\n}\n@media (max-width: 1199px){\n.u-section-1 .u-sheet-1 {min-height: 500px\n}\n}\n.u-section-2 .u-sheet-1 {min-height: 500px\n}\n.u-section-2 .u-text-1 {font-size: 2rem; font-weight: 700; margin: 110px auto 0; color: #4A4A4A;\n}\n.u-section-2 .u-text-2 {margin: 20px 200px 60px; font-size: 1rem; line-height: 26px; color: #626262;\n}\n@media (max-width: 1199px){\n.u-section-2 .u-text-2 {margin-left: 10px; margin-right: 10px\n}\n}\n@media (max-width: 991px){\n.u-section-2 .u-text-2 {margin-left: 0; margin-right: 0\n}\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a3719e94","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/views/historia.vue
// module id = l/h6
// module chunks = 0